import { useIconComponentModel } from './icon-component.model'
import type { IIconComponent } from './icon-component.types'
import { IconComponentView } from './icon-component.view'

export const IconComponent = (props: IIconComponent) => {
  const iconComponentModel = useIconComponentModel(props)
  return <IconComponentView {...iconComponentModel} />
}
